import React from 'react';
import Crousal from "../Components/Crousal/Crousal";
import Services from "../Components/Sevices/Services";
import Acheivement from "../Components/Achievement/Acheivement";
import Contact from "../Components/Contact/Contact";
import About from '../Components/About/About';

export default function Home() {
    return (
        <>
            <Crousal />
            <Services />
            <Acheivement />
            <About />
            <Contact />
        </>
    )
}